import React, { PropsWithChildren } from 'react';

import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';
import ErrorFallback from './components/ErrorFallback/ErrorFallback';

const ErrorBoundary: React.FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const recoverFromError = () => navigate('/');

  return (
    <ReactErrorBoundary FallbackComponent={ErrorFallback} onReset={recoverFromError}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
